import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from './abstractRequest';
import {FormBuilderEnums} from '../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../nddUtils/configurationUtil.service';

@Injectable()
export class RecallRequest extends AbstractRequest {

    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
        super();
        
        this.formFields = [

            {
                key: 'request-option',
                name: 'request-option',
                path: 'request-option',
                label: 'recall.dropdown.select.item',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'optionid',
                        value:'optiondescription'
                    }
                }
            },
            {
                key: 'locations',
                name: 'pickup_location',
                label: 'recall.pickup_location',
                path: 'ordered-locations',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        key: 'pickuplocationcode',
                        value:'pickuplocationname'
                    }
                }

            },
            {
                key: 'last_interest_date',
                name: 'last_interest_date',
                label: 'recall.last_interest_date',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator: {
                    params: {
                        defaultValue: FormBuilderEnums.TODAY,
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'patron_note_1',
                name: 'patron_note_1',
                label: 'recall.patron_note_1',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
           {
                key: 'group_id',
                name: 'group_id',
                label: '',
                mandatory: true,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN

            },   
            {
                key: 'ils_db_code',
                name: 'ils_db_code',
                path: 'optional-service-parameters/ils_db_code',
                label: '',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.HIDDEN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        defaultValue: 'first'
                    }
                   
                }
            }, 
            /* item level */
            {
                key: 'info-notes',
                name: 'info-notes',
                path: FormBuilderEnums.ROOT,
                label: '',
                mandatory: false,
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.INTERNAL,
                uiType: FormBuilderEnums.UI_TYPE.MULTI_LABEL,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this)
                }
            },
            {
                key: 'main_location',
                name: 'main_location',
                path: 'drop-downs/main_location',
                label: 'hold.main_location',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_description',
                name: 'item-description',
                path: 'drop-downs/item_description',
                label: 'hold.item_description',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                duplicateOf : 'item-description',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            },
            {
                key: 'item_category_name',
                name: 'item-category',
                path: 'drop-downs/item_category',
                label: 'hold.item_category',
                mandatory: false,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                duplicateOf : 'item-category',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                   
                },
            
            },
            {
                key: 'item_status_name',
                name: 'item-status-name',
                path: 'drop-downs/item_status',
                label: 'hold.item_status',
                mandatory: true,
                dependOn: {key : 'info-notes', isExists : false},
                value: '',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
                populator:  {
                    func:       this.itemsArrayPopulator.bind(this),
                    params:     {
                        byKey: 'field-name',
                        byValue:'field-values'
                    }
                }
            }        
        ];
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/recallRequest.ts